import { ClickCollect } from '../api/api';

export const filteredHighscore = (highscores: Partial<ClickCollect[]>, limit: number) => {
  if (!highscores || highscores.length === 0) {
    return null;
  }

  // @ts-expect-error I dont want to fix this
  const currentPharmacyIndex = getPharmacyHighscoreIndex(highscores);
  // @ts-expect-error I dont want to fix this
  const list = addIndexValuesToHighscore(highscores);
  const currentPharmacyItem = list.find(
    (pharmacy) => pharmacy.pharmacyId === localStorage.getItem('storeId')
  );
  return currentPharmacyIndex < limit
    ? list.slice(0, limit)
    : // @ts-expect-error I dont want to fix this
      list.slice(0, limit).concat({
        ...currentPharmacyItem,
      });
};

export const addIndexValuesToHighscore = (pharmacies: ClickCollect[]) =>
  pharmacies.map((score, index) => ({
    ...score,
    value: index + 1,
  }));

export const getPharmacyHighscoreIndex = (pharmacies: ClickCollect[] | null) => {
  return pharmacies && pharmacies.length > 0
    ? pharmacies.findIndex((val) => val.pharmacyId === localStorage.getItem('storeId'))
    : 0;
};
